const updates = [
  { id: 1, date: '07.31', title: '《庆余年第三季》官宣开拍，原班人马悉数回归', tag: '新剧' },
  { id: 2, date: '07.30', title: '《狂飙》全集高清版上线，弹幕功能同步开启', tag: '上线' },
  { id: 3, date: '07.29', title: '暑期档专题「国剧盛典」正式上线，百部经典一次看', tag: '专题' },
  { id: 4, date: '07.28', title: '《繁花》加长版独家上线，新增幕后花絮内容', tag: '更新' },
  { id: 5, date: '07.27', title: '《三体》第二季预告片发布，科幻迷翘首以待', tag: '预告' },
  { id: 6, date: '07.26', title: '平台播放器全面升级，支持4K超清画质体验', tag: '升级' },
  { id: 7, date: '07.25', title: '《长相思》播放量破百亿，刷新中国电视剧纪录', tag: '热榜' },
];

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            追剧快讯
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            最新剧集动态与平台更新，追剧不迷路
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          {updates.map((item, idx) => (
            <div
              key={item.id}
              className="relative flex gap-4 pb-5 md:pb-6"
            >
              {idx < updates.length - 1 && (
                <div className="absolute left-[19px] top-10 bottom-0 w-px bg-background-300/60"></div>
              )}
              <div className="flex-shrink-0 w-10 flex flex-col items-center">
                <span className="text-xs font-medium text-foreground-500 whitespace-nowrap">{item.date}</span>
                <div className="w-2.5 h-2.5 rounded-full bg-accent-500 mt-1.5 flex-shrink-0"></div>
              </div>
              <div className="flex-1 min-w-0 pt-0.5">
                <div className="flex items-center gap-2 mb-1">
                  <span className="px-1.5 py-0.5 bg-accent-50 text-accent-700 text-xs rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <p className="text-sm md:text-base text-foreground-800 leading-relaxed">
                  {item.title}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}